import {skipToken} from '@reduxjs/toolkit/query';

import {isNil, isNotNil} from 'ramda';

import {FilterValues, useGetGridTotalRowsQuery} from '@dms/api/core';

import {useDataQuery} from './useDataQuery';

export function useDataGridTotalRows(dataGridCode: string, filters: FilterValues) {
  const {dataQueryId} = useDataQuery(dataGridCode, {filters});

  const {data: totalRows} = useGetGridTotalRowsQuery(
    isNotNil(dataQueryId)
      ? {
          code: dataGridCode,
          dataQueryId: dataQueryId,
        }
      : skipToken
  );

  if (isNil(totalRows)) {
    return undefined;
  }

  return totalRows;
}
